import CDS from "design-system";
import { RadioCard, RadioCardGroup } from "components/FormElements/RadioCardGroup";

export type ViewTypeOption = {
  label: string;
  value: string
};

interface GenericSelectableProps<T extends string> {
  setValue: (value: T) => void;
  value: T;
  defaultValue?: T;
  options: ViewTypeOption[];
}

export default function GenericSelectable<T extends string>({ value, defaultValue, setValue, options }: GenericSelectableProps<T>) {
  return (
    <RadioCardGroup
      name="value"
      value={value}
      defaultValue={defaultValue}
      spacing="2"
      onChange={(changeValue: T) => setValue(changeValue)}
      direction="row"
    >
      {options.map(({ value: innerValue, label }) => (
        <RadioCard includeCheckbox key={innerValue} value={innerValue}>
          <CDS.Text14 size="sm">{label}</CDS.Text14>
        </RadioCard>
      ))}
    </RadioCardGroup>
  );
}
